import { CheckoutState } from '../../state';
import { getIsAppRebrandActiveFromURL } from '../../utils/getIsAppRebrandActiveFromURL';

export const getIsAppRebrandActive = ({ app }: CheckoutState) => {
    const appRebrandParam = app?.request?.params?.is_app_rebrand_active;

    return (
        ['true', '1'].includes(appRebrandParam as string) ||
        getIsAppRebrandActiveFromURL()
    );
};
